import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { CommentQuestionIcon } from '../theme/Icons';
import { IAgencyBeaSurface } from './AgencyBeaState';
import { useAgencyBea } from './useAgencyBea';

const useStyles = createUseStyles({
    label: {
        marginLeft: 8
    }
});

/** Opens agency Bea over the whole caseload from a tab of the agency home. Shown only where the api offers the caseload chat. */
export const AskBeaButton: FC<{ surface: IAgencyBeaSurface; 'data-id'?: string }> = ({ surface, 'data-id': dataId }) => {
    const classes = useStyles();
    const openBea = useAgencyBea();

    if (!openBea) {
        return null;
    }

    return (
        <IonButton fill="outline" color="primary" data-id={dataId || 'ask-bea-about-clients'} onClick={() => openBea({ surface })}>
            <CommentQuestionIcon color="primary" customSize={18} />
            <span className={classes.label}>Ask Bea about your clients</span>
        </IonButton>
    );
};
